import { createContext } from "react";

export const PedidosContext = createContext()
export const PedidosFormContext = createContext()
export const PedidosReportContext = createContext()